module.exports = __webpack_public_path__ + "2fca5c8e275ef8eee3c76972434467f5.MP3";